import { render, staticRenderFns } from "./BopModelSetup.vue?vue&type=template&id=2903c60a&scoped=true"
import script from "./BopModelSetup.vue?vue&type=script&lang=ts"
export * from "./BopModelSetup.vue?vue&type=script&lang=ts"
import style0 from "./BopModelSetup.vue?vue&type=style&index=0&id=2903c60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2903c60a",
  null
  
)

export default component.exports